// Misc metadata-adjacent actions that used to live in features/metadataWizard.ts
// (now removed). These are NOT part of the metadata wizard — they belong to other
// features and are kept here:
//   - metadataqueue     → MetadataQueue component (AI-tagging queue)
//   - saveartistcoll    → ArtistDetailsModal (set an artist's collection)
//   - setAllUploadsToCat→ uploader: bulk-set category on the upload page
import { registerActions } from "../actionRegistry";
import { api as backend } from "../api";
import { toastSuccess, toastError } from "../ui/messages";
import { queryAll } from "../utils/dom";
import { mountMetadataQueue } from "./components/MetadataQueue";

export function setAllUploadsToCat(cat_id: string): void {
  queryAll<HTMLSelectElement>(".uploaderCatSelect").forEach((el) => {
    if (el.value === "") {
      el.value = cat_id;
      el.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
}

export async function saveartistcoll(user_id: string, coll_id: string): Promise<void> {
  try {
    await backend.artists.saveCollection({ id: Number(user_id), coll_id });
    toastSuccess("Artist collection set");
  } catch (err: unknown) {
    toastError((err as Error).message);
  }
}

export function metadataqueue(): void {
  mountMetadataQueue();
}

registerActions({
  setAllUploadsToCat,
});
